"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useVisualProps = useVisualProps;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _constants = require("./constants");
function useVisualProps(props) {
    var theme = (0, _mui.useTheme)();
    var _props_elevation = props.elevation, elevation = _props_elevation === void 0 ? 2 : _props_elevation, _props_expandOnFocus = props.expandOnFocus, expandOnFocus = _props_expandOnFocus === void 0 ? false : _props_expandOnFocus, height = props.height, _props_IconButtonProps = props.IconButtonProps, IconButtonProps = _props_IconButtonProps === void 0 ? {} : _props_IconButtonProps, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, _props_variant = props.variant, variant = _props_variant === void 0 ? 'contained' : _props_variant, width = props.width;
    var pickerHeight = (0, _react.useMemo)(function() {
        if (typeof height === 'number' && height >= _constants.TEXT_MEDIUM_HEIGHT) {
            if (variant === 'text' && size === 'medium' && height > _constants.TEXT_MEDIUM_HEIGHT) {
                return "".concat(height, "rem");
            }
            if (variant === 'text' && size === 'large' && height > _constants.TEXT_LARGE_HEIGHT) {
                return "".concat(height, "rem");
            }
            if (variant === 'contained' && size === 'medium' && height > _constants.CONTAINED_MEDIUM_HEIGHT) {
                return "".concat(height, "rem");
            }
            if (variant === 'contained' && size === 'large' && height > _constants.CONTAINED_LARGE_HEIGHT) {
                return "".concat(height, "rem");
            }
        }
        return undefined;
    }, [
        height,
        size,
        variant
    ]);
    var cssProps = (0, _react.useMemo)(function() {
        var shadowLevel = elevation >= 0 && elevation <= 24 ? Math.floor(elevation) : 2;
        var pickerWidth = typeof width === 'undefined' ? '100%' : typeof width === 'number' ? "".concat(width, "px") : width;
        var contained = variant === 'contained';
        var _theme_shadows_shadowLevel;
        var pickerCssProps = {
            holder: {
                gridTemplateColumns: contained ? "".concat(_constants.CONTAINED_MEDIUM_BUTTON_SIZE, " ").concat(_constants.MEDIUM_INPUT_WIDTH, " ").concat(_constants.CONTAINED_MEDIUM_BUTTON_SIZE) : "".concat(_constants.TEXT_MEDIUM_BUTTON_SIZE, " ").concat(_constants.MEDIUM_INPUT_WIDTH, " ").concat(_constants.TEXT_MEDIUM_BUTTON_SIZE),
                height: contained ? "".concat(_constants.CONTAINED_MEDIUM_HEIGHT, "rem") : "".concat(_constants.TEXT_MEDIUM_HEIGHT, "rem"),
                minWidth: _constants.MEDIUM_MIN_WIDTH,
                width: pickerWidth,
                padding: contained ? _constants.CONTAINED_PADDING : _constants.TEXT_PADDING,
                borderRadius: contained ? 100 : 0,
                background: contained ? theme.palette.common.white : 'transparent',
                boxShadow: contained ? (_theme_shadows_shadowLevel = theme.shadows[shadowLevel]) !== null && _theme_shadows_shadowLevel !== void 0 ? _theme_shadows_shadowLevel : 'none' : 'none'
            },
            button: {
                fontSize: contained ? _constants.CONTAINED_MEDIUM_FONT_SIZE : _constants.TEXT_MEDIUM_FONT_SIZE,
                width: contained ? _constants.CONTAINED_MEDIUM_BUTTON_SIZE : _constants.TEXT_MEDIUM_BUTTON_SIZE,
                height: contained ? _constants.CONTAINED_MEDIUM_BUTTON_SIZE : _constants.TEXT_MEDIUM_BUTTON_SIZE
            },
            input: {
                minWidth: _constants.MEDIUM_INPUT_WIDTH,
                width: _constants.MEDIUM_INPUT_WIDTH,
                height: contained ? _constants.CONTAINED_MEDIUM_BUTTON_SIZE : _constants.TEXT_MEDIUM_BUTTON_SIZE
            }
        };
        if (size === 'large') {
            pickerCssProps.holder.gridTemplateColumns = "".concat(_constants.LARGE_BUTTON_SIZE, " ").concat(_constants.LARGE_INPUT_WIDTH, " ").concat(_constants.LARGE_BUTTON_SIZE);
            pickerCssProps.holder.height = contained ? "".concat(_constants.CONTAINED_LARGE_HEIGHT, "rem") : "".concat(_constants.TEXT_LARGE_HEIGHT, "rem");
            pickerCssProps.holder.minWidth = _constants.LARGE_MIN_WIDTH;
            pickerCssProps.button.fontSize = _constants.LARGE_FONT_SIZE;
            pickerCssProps.input.minWidth = _constants.LARGE_INPUT_WIDTH;
            pickerCssProps.input.width = _constants.LARGE_INPUT_WIDTH;
            pickerCssProps.input.height = _constants.LARGE_BUTTON_SIZE;
            pickerCssProps.button.width = _constants.LARGE_BUTTON_SIZE;
            pickerCssProps.button.height = _constants.LARGE_BUTTON_SIZE;
        }
        if (pickerHeight) {
            pickerCssProps.holder.height = pickerHeight;
        }
        if (expandOnFocus) {
            pickerCssProps.holder.background = 'transparent';
            pickerCssProps.holder.boxShadow = 'none';
            pickerCssProps.holder.padding = '0';
            pickerCssProps.holder.minWidth = 26;
            pickerCssProps.holder.width = '34px';
            pickerCssProps.holder.height = '26px';
            pickerCssProps.input.minWidth = '34px';
            pickerCssProps.input.width = '34px';
            pickerCssProps.input.height = '26px';
            pickerCssProps.button.fontSize = '20px';
            pickerCssProps.button.width = '26px';
            pickerCssProps.button.height = '26px';
        }
        return pickerCssProps;
    }, [
        elevation,
        expandOnFocus,
        pickerHeight,
        size,
        theme.palette.common.white,
        theme.shadows,
        variant,
        width
    ]);
    var buttonProps = (0, _react.useMemo)(function() {
        var baseProps = _object_spread({}, IconButtonProps);
        baseProps.type = 'button';
        baseProps.size = 'small';
        baseProps.variant = 'contained';
        baseProps.color = 'secondary';
        if (expandOnFocus) {
            return baseProps;
        }
        if (size === 'large') {
            baseProps.size = 'medium';
        }
        if (variant === 'text') {
            baseProps.size = 'medium';
        }
        if (variant === 'contained') {
            baseProps.variant = 'text';
            baseProps.color = 'default';
        }
        return baseProps;
    }, [
        IconButtonProps,
        expandOnFocus,
        size,
        variant
    ]);
    return {
        cssProps: cssProps,
        buttonProps: buttonProps
    };
} //# sourceMappingURL=useVisualProps.js.map
